import {Lang} from 'yougile-lang'
import {logger} from 'yougile-util'
import {DragData} from './drag-data'

window.addEventListener('drop', (e: DragEvent) => {
  e.preventDefault()
  // if (DragData.get().type === 'empty') {
  //   e.preventDefault();
  // }
})

window.addEventListener('dragover', (e: DragEvent) => {
  if (DragData.get().type === 'empty') {
    e.preventDefault()
  }
})

export class DropFileArea {
  onDropAction: (e: DragEvent) => void
  element: Element
  isActive: boolean

  static attachTo(element: Element): DropFileArea {
    const result = new DropFileArea(element)
    element.classList.add('drop-file-area')
    return result
  }

  constructor(element: Element) {
    this.element = element
    this.onDropAction = () => {
      //
    }
    this.isActive = true
    this.addBehaviors()
  }

  private onDragEnter = (e: DragEvent) => {
    const dataTransfer = e.dataTransfer
    if (DragData.get().type !== 'empty' || !dataTransfer) {
      return
    }
    if (!this.isActive) {
      return
    }
    e.preventDefault()
    DragData.setEffect({dataTransfer}, 'copy')
    this.element.classList.add('drop-file-area-active')
    this.element.setAttribute('data-drop-hint', Lang.msg.dropFileToChat)
  }

  private onDragLeave = (e: DragEvent) => {
    if (DragData.get().type !== 'empty') {
      return
    }
    if (!this.isActive) {
      return
    }
    e.preventDefault()
    this.element.classList.remove('drop-file-area-active')
  }

  private onDrop = (e: DragEvent) => {
    if (DragData.get().type !== 'empty') {
      logger.log('drop: drag data is not empty, skipping…')
      return
    }
    if (!this.isActive) {
      logger.log('drop: not active, skipping…')
      return
    }
    e.preventDefault()
    this.element.classList.remove('drop-file-area-active')
    this.onDropAction(e)
  }

  private addBehaviors(): void {
    this.element.addEventListener('dragenter', this.onDragEnter)
    this.element.addEventListener('dragleave', this.onDragLeave)
    this.element.addEventListener('drop', this.onDrop)
  }

  removeBehaviors(): void {
    this.element.removeEventListener('dragenter', this.onDragEnter)
    this.element.removeEventListener('dragleave', this.onDragLeave)
    this.element.removeEventListener('drop', this.onDrop)
  }
}
